import {
  call, put, takeLatest, all, select,
} from 'redux-saga/effects';
import {
  setEncargosWorkspace, setWorkspaceLoading,
  devolverArticuloDeEncargoSuccess, fetchEncargoAndLoadIntoWorkspace,
} from '../actions/creators/encargos.actioncreator';
import { authRequest } from '../../helpers/request.helper';
import { showInfo, showSuccess, toastDanger } from '../actions/creators/mensajesSistema.actioncreator';

import {
  ENCARGOS_CREAR_PRESUPUESTO_RAPIDO, ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_FAILURE,
  ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_REQUEST, ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_SUCCESS,
  ENCARGOS_DEVOLVER_ARTICULOS_REQUEST, ENCARGOS_DEVOLVER_ARTICULOS_FAILURE,
  ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS, ENCARGOS_COBRAR_REQUEST, ENCARGOS_COBRAR_SUCCESS, ENCARGOS_COBRAR_FAILURE,
} from '../actions/constants/encargos.constants';
import {autoFormatCurrency} from "../../helpers/common.helper";

const encargosWorkspaceState = state => state.encargosWorkspace;
const authState = state => state.auth;
const coreState = state => state.core;

function* setWorkspace({ payload: { encargoId, tiendaId } }) {
  const core = yield select(coreState);
  try {
    yield put(setEncargosWorkspace([], null));
    const params = {
      url: `api/encargopromocional/${encargoId}`,
      method: 'POST',
      body: JSON.stringify({
        tienda_id: tiendaId,
      }),
    };
    const {
      encargos, promocion, resumenPrecios, tituloEspacioDeTrabajo,
    } = yield call(authRequest, params);

    const encargosMapped = encargos.map((encargo) => {
      const {
        promocionInfo, articulosAgrupados, paciente, gestor,
      } = encargo;
      let nombre = 'Encargo simple';
      if (promocionInfo && promocionInfo.nombre) {
        nombre = promocionInfo.nombre;
      }
      let detalles = [];
      articulosAgrupados.forEach(({ detalles: detallesAgrupados }) => {
        const tiposArticulos = core.tiposArticulo;
        const detallesFormateados = detallesAgrupados.map(({
          articulo, tipo_articulo, linea, descripcion, unidades, precio: precioSinParse,
        }) => ({
          cdgtipo: tipo_articulo,
          cadenaTipo: tiposArticulos.find(({ id }) => id == tipo_articulo).nombre,
          linea,
          articulo,
          descripcion,
          unidades,
          precio: parseFloat(precioSinParse),
        }));
        detalles = detalles.concat(detallesFormateados);
      });
      return {
        nombre,
        ...encargo,
        cabecera: {
          fechaCreacion: encargo.fecha_emision,
          fechaCreacionPretty: encargo.fechaEmisionFormateada,
          tipoEncargoId: encargo.tipo_venta ? encargo.tipo_venta.id : null,
          motivoVisitaId: encargo.motivo_compra ? encargo.motivo_compra.id : null,
          numeroTalon: encargo.talon,
          cliente: {
            id: paciente.id,
            nombreCompleto: paciente.nombre_completo,
            tiendaId: paciente.tienda_id,
            fechaUltimaGraduacionOptometrica: paciente.fecha_ultima_gradopt,
            fechaUltimaGraduacionContactologica: paciente.fecha_ultima_gradcontac,
            codigoGrupoCliente: paciente.cod_grupo_cliente,
          },
          gestorId: gestor.id,
        },
        detalles,
      };
    });

    yield put(setEncargosWorkspace({
      encargos: encargosMapped,
      promocion,
      resumenPrecios,
      tituloEspacioDeTrabajo,
      editable: false,
    }));
    yield put({ type: ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_SUCCESS });
  } catch (error) {
    yield put(setWorkspaceLoading({ loading: false }));
    yield put({ type: ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_FAILURE, payload: error });
  }
}

function* setPresupuestoRapidoWorkspace({ payload: { tiendaId, encargoId } }) {
  try {
    yield put(setEncargosWorkspace({
      encargos: [
        {
          id: encargoId,
          tienda_id: tiendaId,
          paciente_id: null,
          articulos: [],
          cobros: [],
          promocionInfo: null,
          total: 0,
        },
      ],
      editable: true,
      promocion: false,
      resumenPrecios: {
        total: 0,
        totalPendiente: null,
      },
      tituloEspacioDeTrabajo: 'Presupuesto rápido',
    }));
  } catch (error) {

  }
}

function* devolverArticulosEncargo({
  payload:
  {
    imprimirTicket, formaPago, motivoDevolucion, notaMotivoDevolucion,
    usuarioDevolucion, articulosSeleccionados, encargoId, tiendaId,
  },
}) {
  try {
    const params = {
      url: `api/encargo/${encargoId}/devolver`,
      method: 'POST',
      body: JSON.stringify({
        tienda_id: tiendaId,
        articulos: articulosSeleccionados,
        es_regularizacion: false,
        usuario_id: usuarioDevolucion,
        cobros_devolucion: null,
        motivo_devolucion_id: motivoDevolucion,
        nota: notaMotivoDevolucion,
      }),
    };

    const response = yield call(authRequest, params);
    const {
      id, tienda, error_code: errorCode, error_message: errorMessage,
    } = response;
    if ((id !== null) && (tienda !== null)) {
      yield put(showInfo({ title: 'Devolución', message: 'Devuelto correctamente' }));
      yield put(fetchEncargoAndLoadIntoWorkspace(encargoId, tiendaId));
    } else {
      yield put(toastDanger({ httpError: { response: { data: { error_message: `Error al devolver: ${errorMessage}` } } } }));
    }
    // yield put({ type: ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS });
  } catch (error) {
    // yield put({ type: ENCARGOS_DEVOLVER_ARTICULOS_FAILURE });
    yield put(toastDanger({ httpError: { response: { data: { error_message: `Error al devolver: ${error.response.data.exception_message}` } } } }));
  }
}

function* cobrarEncargos({ payload }) {
  const encargosWorkspace = yield select(encargosWorkspaceState);
  const auth = yield select(authState);
  try {
    const { resumenPrecios: { totalPendiente } } = encargosWorkspace;
    const { user: { user_info: { tienda_id: tiendaId } } } = auth;
    const {
      importe, encargosChecked, formaPago, agente, modoPago,
    } = payload;
    const { id: cobradoPorAgenteId } = agente;
    const { id: formaPagoId, es_efectivo: esEfectivo } = formaPago;
    let importeACobrar = importe;
    let importeADevolver = 0;
    if (esEfectivo && parseInt(importe) > parseInt(totalPendiente)) {
      importeACobrar = parseInt(totalPendiente);
      importeADevolver = parseInt(importe) - parseInt(totalPendiente);
    }
    const formData = new FormData();
    formData.append('encargos', JSON.stringify(encargosChecked));
    formData.append('forma_pago_id', formaPagoId);
    formData.append('cobrado_por_agente_id', cobradoPorAgenteId);
    formData.append('importe', importeACobrar);
    formData.append('tienda_id', tiendaId);
    if (modoPago !== null) {
      if (modoPago === 'financiacion') {
        const { meses, nombreClienteFinancia, nifClienteFinancia } = payload;
        formData.append('informacion_extra_forma_pago', JSON.stringify({
          modo: 'financiacion',
          meses,
          nif: nifClienteFinancia,
          nombre_cliente_financia: nombreClienteFinancia,
        }));
      } else if (modoPago === 'vale') {
        const { numeroDeVale } = payload;
        formData.append('informacion_extra_forma_pago', JSON.stringify({
          modo: 'vale',
          numero_de_vale: numeroDeVale,
        }));
      }
    }
    const requestParams = {
      url: 'api/encargo/cobrar',
      method: 'POST',
      body: formData,
    };
    yield call(authRequest, requestParams);
    yield put({ type: ENCARGOS_COBRAR_SUCCESS });
    const { encargos } = encargosWorkspace;
    const encargo = encargos[0];
    const { id: encargoId, tienda: { id: tiendaEncargoId } } = encargo;
    if (importeADevolver > 0) {
      const message = `El cambio para el cliente es de: ${autoFormatCurrency(importeADevolver)}`;
      yield put(showSuccess({ title: 'Cobrado', message }));
    } else {
      yield put(showSuccess({ title: 'Cobrado', message: 'Se ha completado el cobro' }));
    }
    yield put(fetchEncargoAndLoadIntoWorkspace(encargoId, tiendaEncargoId));
  } catch (ex) {
    yield put({ type: ENCARGOS_COBRAR_FAILURE });
  }
}

function* encargosSaga() {
  yield all([
    takeLatest(ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_REQUEST, setWorkspace),
    takeLatest(ENCARGOS_CREAR_PRESUPUESTO_RAPIDO, setPresupuestoRapidoWorkspace),
    takeLatest(ENCARGOS_DEVOLVER_ARTICULOS_REQUEST, devolverArticulosEncargo),
    takeLatest(ENCARGOS_COBRAR_REQUEST, cobrarEncargos),
  ]);
}

export default encargosSaga;
